import { Component, Inject, OnInit } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { DashboardWidget } from '../../../../../../models/entities/dashboard-widget';
import { OrganizationService } from '../../../../../../services/organization/organization.service';
import { GrowlerService } from '../../../../../../services/growler.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { MatLegacySlideToggleChange as MatSlideToggleChange } from '@angular/material/legacy-slide-toggle';

@UntilDestroy()
@Component({
    selector: 'app-dialog-dash-widget-sort',
    templateUrl: './dialog-dash-widget-sort.component.html',
})
export class DialogDashWidgetSortComponent implements OnInit
{
    allWidgets: DashboardWidget[] = [];
    slideInitialValues: { [id: number]: boolean; } = {};
    isSaving = false;

    constructor(
            private _dialogRef: MatDialogRef<DialogDashWidgetSortComponent>,
            private _growler: GrowlerService,
            private _organizationService: OrganizationService,
            @Inject(MAT_DIALOG_DATA) public data: DashboardWidget[],
    ) {
    }

    ngOnInit() {
        this.allWidgets = [...this.data];
        this.slideInitialValues = {};
    }

    storeInitial(widget: DashboardWidget, event: MatSlideToggleChange) {
        // we store initial slide toggle value to reset on cancel
        if (!(widget.id in this.slideInitialValues)) {
            this.slideInitialValues[widget.id] = !widget.isEnabled;
        }
    }

    drop(event: CdkDragDrop<string[]>) {
        moveItemInArray(this.allWidgets, event.previousIndex, event.currentIndex);
    }

    cancelUpdate() {
        // revert changes performed before cancel
        this.allWidgets = this.allWidgets.map((widget) => {
            if (widget.id in this.slideInitialValues) {
                widget.isEnabled = this.slideInitialValues[widget.id];
            }
            return widget;
        });

        // clear out widgets
        this.allWidgets = [];

        this._dialogRef.close([]);
    }

    /**
     * Update sort or isVisible on the widgets; close and update parent widget component.
     */
    updateDashboardWidgets() {
        this.isSaving = true;

        // for now, they have to enable at least one; maybe later let them have none and don't show the widgets
        // and let them show/hide the entire widget block in org settings or something
        if (!this.allWidgets.find(w => w.isEnabled)) {
            this._growler.error('Error', 'Please choose at least one widget to display.');
            this.isSaving = false;
            return;
        }

        // adjust the rank before saving, based on visible order from their drag and drop
        const updateData: { id: number; rank: number; isEnabled: boolean }[] = [];
        this.allWidgets.forEach((w: DashboardWidget, i: number) => {
            w.rank = i + 1;
            updateData.push({
                id: w.id,
                rank: w.rank,
                isEnabled: w.isEnabled,
            });
        });

        this.allWidgets = this.allWidgets.sort((a, b) => a.rank - b.rank);

        this._organizationService.updateOrgDashboardWidgetOrder(updateData).pipe(untilDestroyed(this)).subscribe({
            next: () => {
                this._growler.success('Success', 'Widgets have been updated for your dashboard.');
                this._dialogRef.close(this.allWidgets);
            },
            error: () => {
                this._growler.error('Error', 'There was an error updating the widgets for your dashboard.');
                this.isSaving = false;
            },
        });
    }
}
